<template>
    <div class="alert-mask" v-show="show">
        <div class="modal-align-center">
            <div class="modal-box">
                <!--<img src="/static/img/alert/close@2x.png" class="closeBtn" v-if="hasBtn">-->
                <div class="modal-title" v-if="alertTitle" v-html="alertTitle"></div>
                <div class="modal-message">
                    <div v-html="alertMessage"></div>
                    <slot></slot>
                    <div class="alert-rule" v-if="rule">
                        <img :src="select?'/static/img/common/select@2x.png':'/static/img/common/unselect@2x.png'"
                             @click="selectFun">
                        <span v-html="rule"></span>
                    </div>
                </div>
                <div class="modal-single-btn" v-show="singleBtn">
                    <div @click="sure" class="modal-sure">{{sureTxt!=''?sureTxt:'确定'}}</div>
                </div>
                <div class="modal-btn" v-if="!singleBtn">
                    <div @click="cancel" class="modal-cancel">{{cancelTxt!=''?cancelTxt:'取消'}}</div>
                    <div v-if="sureClick" @click="sure" class="modal-sure">{{sureTxt!=''?sureTxt:'确定'}}</div>
                    <div v-if="!sureClick" class='modal-sure'>{{sureTxt!=''?sureTxt:'确定'}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'alert',
  data () {
    return {
      show: false,
      sureTxt: '确定',
      cancelTxt: '取消',
      singleBtn: false,
      rule: false,
      select: true,
      sureClick: true,
      alertTitle: '',
      alertMessage: '',
      sureFun: function () {
      },
      cancelFun: function () {
      },
      isSureAlertFun: true
    }
  },
  methods: {
    defaultData: function () {
      this.show = false
      this.sureTxt = '确定'
      this.cancelTxt = '取消'
      this.singleBtn = false
      this.rule = false
      this.select = true
      this.sureClick = true
      this.alertTitle = ''
      this.alertMessage = ''
      this.sureFun = function () {
      }
      this.cancelFun = function () {
      }
    },
    setProps (data) {
      let me = this
      me.defaultData()
      for (var item in data) {
        me[item] = data[item]
      }
      me.show = true
    },
    closeAlert: function () {
      this.show = false
    },
    sure () {
      if (this.isSureAlertFun) {
        this.show = false
      }
      this.sureFun()
    },
    sureAlertFun () {
      this.sureFun()
    },
    cancel (cancelFun) {
      this.show = false
      this.cancelFun()
    },
    selectFun: function () {
      this.select = !this.select
      this.sureClick = !this.sureClick
      if (this.select) {
        this.sureClick = true
      }
    }
  }
}
</script>

<style scoped>
    .modal-box {
        width: 580px;
        /*height: 402px;*/
        overflow: hidden;
        position: fixed;
        left: 86px;
        background: #fff;
        border-radius: 12px;
        padding: 60px 0 0;
        top: 338px;
        /*font-family: PingFangSC-Medium;*/
    }

    .modal-title {
        text-align: center;
        color: #000;
        font-size: 32px; /*px*/
        padding-bottom: 30px;
        font-weight: bold;
    }

    .modal-message {
        font-size: 28px; /*px*/
        padding: 0 38px;
        text-align: center;
        color: #17181A;
        word-break: break-all;
    }

    .modal-btn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 30px; /*px*/
        border-top: 2px solid rgba(0, 0, 0, 0.08);
    }

    .modal-single-btn {
        border-top: 2px solid rgba(0, 0, 0, 0.08);
        font-size: 30px; /*px*/
    }

    .modal-cancel {
        width: 100%;
        line-height: 86px;
        text-align: center;
        color: #BDC1C7;
        border-right: 2px solid rgba(0, 0, 0, 0.08);
    }

    .modal-sure {
        width: 100%;
        line-height: 86px;
        text-align: center;
        color: #4DA6FF;
    }

    .top-coupon {
        margin-top: -130px;
    }

    .alert-mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background: rgba(0, 0, 0, 0.50);
    }

    .closeBtn {
        width: 48px;
        height: 48px;
        position: absolute;
        right: 20px;
        top: 20px
    }

    .modal-btn, .modal-single-btn {
        margin-top: 40px;
    }

    .alert-rule {
        /*display: flex;*/
        align-items: center;
        margin-top: 30px;
    }

    .alert-rule img {
        width: 28px;
        height: 28px;
        margin-right: 10px;

    }

    a {
        color: #4DA6FF !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/alert/alert.vue